(function () {
  'use strict';

  if (window.rofMobileNavigationCaptureFixLoaded) return;
  window.rofMobileNavigationCaptureFixLoaded = true;

  var MOBILE_MAX = 1024;

  function elements() {
    return {
      toggle: document.querySelector('.mobile-menu-toggle'),
      nav: document.querySelector('.nav')
    };
  }

  function isMobile() {
    return window.innerWidth <= MOBILE_MAX;
  }

  function directChild(item, selector) {
    if (!item) return null;
    for (var i = 0; i < item.children.length; i += 1) {
      if (item.children[i].matches(selector)) return item.children[i];
    }
    return null;
  }

  function setToggleState(toggle, isOpen) {
    if (!toggle) return;
    toggle.setAttribute('aria-expanded', String(isOpen));
    toggle.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
  }

  function closeSubmenus(nav, exceptItem) {
    if (!nav) return;
    nav.querySelectorAll('.nav-item.open').forEach(function (item) {
      if (item === exceptItem) return;
      item.classList.remove('open');
      var link = directChild(item, '.nav-link');
      if (link) link.setAttribute('aria-expanded', 'false');
    });
  }

  function closeMenu(returnFocus) {
    var parts = elements();
    if (!parts.nav) return;

    parts.nav.classList.remove('nav-open');
    document.body.classList.remove('mobile-nav-open', 'menu-open');
    closeSubmenus(parts.nav, null);
    setToggleState(parts.toggle, false);

    if (returnFocus && parts.toggle) parts.toggle.focus();
  }

  function toggleMenu() {
    var parts = elements();
    if (!parts.nav || !parts.toggle) return;

    var willOpen = !parts.nav.classList.contains('nav-open');
    parts.nav.classList.toggle('nav-open', willOpen);
    document.body.classList.toggle('mobile-nav-open', willOpen);
    document.body.classList.toggle('menu-open', willOpen);
    setToggleState(parts.toggle, willOpen);

    if (!willOpen) closeSubmenus(parts.nav, null);
  }

  function prepareAccessibility() {
    var parts = elements();
    if (!parts.toggle || !parts.nav) return;

    if (!parts.toggle.hasAttribute('aria-controls')) {
      if (!parts.nav.id) parts.nav.id = 'MainMobileNavigation';
      parts.toggle.setAttribute('aria-controls', parts.nav.id);
    }
    setToggleState(parts.toggle, parts.nav.classList.contains('nav-open'));

    parts.nav.querySelectorAll('.nav-item').forEach(function (item) {
      var link = directChild(item, '.nav-link');
      var dropdown = directChild(item, '.dropdown');
      if (!link || !dropdown) return;
      link.setAttribute('aria-haspopup', 'true');
      link.setAttribute('aria-expanded', String(item.classList.contains('open')));
    });
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest && event.target.closest('.mobile-menu-toggle');
    if (toggle) {
      event.preventDefault();
      event.stopImmediatePropagation();
      toggleMenu();
      return;
    }

    var link = event.target.closest && event.target.closest('.nav-item > .nav-link');
    if (link && isMobile()) {
      var item = link.parentElement;
      var dropdown = directChild(item, '.dropdown');

      if (dropdown) {
        event.preventDefault();
        event.stopImmediatePropagation();

        var parts = elements();
        var willOpen = !item.classList.contains('open');
        closeSubmenus(parts.nav, item);
        item.classList.toggle('open', willOpen);
        link.setAttribute('aria-expanded', String(willOpen));
        return;
      }
    }

    var parts = elements();
    if (
      isMobile() &&
      parts.nav &&
      parts.nav.classList.contains('nav-open') &&
      !parts.nav.contains(event.target) &&
      (!parts.toggle || !parts.toggle.contains(event.target))
    ) {
      closeMenu(false);
    }
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      var parts = elements();
      if (parts.nav && parts.nav.classList.contains('nav-open')) {
        event.preventDefault();
        closeMenu(true);
      }
    }
  }, true);

  window.addEventListener('resize', function () {
    if (!isMobile()) closeMenu(false);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', prepareAccessibility, { once: true });
  } else {
    prepareAccessibility();
  }

  document.addEventListener('shopify:section:load', prepareAccessibility);
})();